export const POPULAR_MANUFACTURE = [
  {
    manufacturer: "CARDONE INDUSTRIES",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/CARDONE INDUSTRIES_small.png",
    url: "/cardone-industries",
  },
  {
    manufacturer: "RAYBESTOS",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/RAYBESTOS_small.png",
    url: "/raybestos",
  },
  {
    manufacturer: "WALKER",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/WALKER_small.png",
    url: "/walker",
  },
  {
    manufacturer: "DORMAN/AUTOGRADE",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/DORMAN-AUTOGRADE_small.png",
    url: "/dorman-autograde",
  },
  {
    manufacturer: "BOSCH",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/BOSCH_small.png",
    url: "/bosch",
  },
  {
    manufacturer: "MEVOTECH ORIGINAL GRADE",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/MEVOTECH ORIGINAL GRADE_small.png",
    url: "/mevotech-original-grade",
  },
  {
    manufacturer: "SPECTRA PREMIUM INDUSTRIES",
    manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/SPECTRA PREMIUM INDUSTRIES_small.png",
    url: "/spectra-premium-industries",
  },
];
